// GrowthBook flag for Matchningsvy v3, A/B tested against new-matches. It
// does not depend on new-matches: on its own it shows the matches view with
// the v3 parts, so new-matches can be turned off for the v3 group.
export const MATCHES_V3_FLAG = 'matches-v3';

export function isMatchesV3Enabled(growthbook) {
  return !!(growthbook && growthbook.isFeatureFlagEnabled(MATCHES_V3_FLAG));
}
